<nav
  *ngIf="user"
  id="sidebar"
  [ngClass]="collapsed === true ? 'tablet' : 'extend-tablet'"
  class="shadow-sm"
>
  <ul class="nav flex-column">
    <li class="nav-item">
      <a
        class="mt-3 mb-3 brand-logo nav-link active"
        id="logo"
        (click)="navigate('/registration-requests')"
        aria-current="page"
      >
        <div style="padding-right: 4px; text-align: center">
          <img src="../../../assets/icons/MOWA_logo.png" height="77" alt="Logo" />
        </div>
      </a>
    </li>
    <ng-container *ngIf="user">
      <li class="nav-item" *ngIf="user.role !== 'mowa_admin'">
        <a
          class="nav-link to-be-hidden"
          [class]="activeTab == '/users/' + user.id ? 'active' : ''"
          (click)="navigate('users/' + user.id)"
          ><span
            ><img
              src="../../../assets/icons/icon_person_inactive.svg"
              class="icon"
              style="height: 32px"
              alt="" /><img
              src="../../../assets/icons/icon_person_active.svg"
              class="active-icon"
              style="height: 32px"
              alt=""
          /></span>
          {{ 'sitebar.my-account' | translate }}</a
        >
      </li>
    </ng-container>
    <li class="nav-item">
      <a
        class="nav-link to-be-hidden"
        [class]="activeTab == '/registration-requests' || activeTab == '/' ? 'active' : ''"
        (click)="navigate('/registration-requests')"
        aria-current="page"
        ><span>
          <img
            src="../../../assets/icons/icon_requests_inactive.svg"
            class="icon"
            style="height: 32px"
            alt=""
          /><img
            src="../../../assets/icons/icon_requests_active.svg"
            class="active-icon"
            style="height: 32px"
            alt=""
          />
        </span>
        {{ 'sitebar.registration-request' | translate }}</a
      >
    </li>
    <li class="nav-item">
      <a
        class="nav-link to-be-hidden"
        [class]="activeTab == '/companies' ? 'active' : ''"
        (click)="navigate('companies')"
        ><span
          ><img
            src="../../../assets/icons/icon_company_inactive.svg"
            class="icon"
            style="height: 32px"
            alt="" /><img
            src="../../../assets/icons/icon_company_active.svg"
            class="active-icon"
            style="height: 32px"
            alt=""
        /></span>
        {{ 'sitebar.manage-companies' | translate }}</a
      >
    </li>
    <li class="nav-item">
      <a
        class="nav-link to-be-hidden"
        [class]="activeTab == '/users' ? 'active' : ''"
        (click)="navigate('users')"
        ><span
          ><img
            src="../../../assets/icons/icon_users_inactive.svg"
            class="icon"
            style="height: 32px"
            alt="" /><img
            src="../../../assets/icons/icon_users_active.svg"
            class="active-icon"
            style="height: 32px"
            alt=""
        /></span>
        {{ 'sitebar.manage-user' | translate }}</a
      >
    </li>
    <li class="nav-item" *ngIf="isMowaAdmin">
      <a
        class="nav-link to-be-hidden"
        [class]="activeTab == '/proposals-and-orders' ? 'active' : ''"
        (click)="navigate('proposals-and-orders')"
        ><span
          ><img
            src="../../../assets/icons/icon_orders_inactive.svg"
            class="icon"
            style="height: 32px"
            alt="" /><img
            src="../../../assets/icons/icon_orders_active.svg"
            class="active-icon"
            style="height: 32px"
            alt=""
        /></span>
        {{ 'sitebar.proposals-and-orders' | translate }}</a
      >
    </li>
    <li class="nav-item" *ngIf="isMowaAdmin">
      <a
        class="nav-link to-be-hidden"
        [class]="activeTab == '/trainings' ? 'active' : ''"
        (click)="navigate('trainings')"
        ><span
          ><img
            src="../../../assets/icons/icon_trainings_inactive.svg"
            class="icon"
            style="height: 32px"
            alt="" /><img
            src="../../../assets/icons/icon_trainings_active.svg"
            class="active-icon"
            style="height: 32px"
            alt=""
        /></span>
        {{ 'Training' | translate }}</a
      >
    </li>
    <li class="nav-item">
      <a
        class="nav-link to-be-hidden"
        [class]="activeTab == '/video-tutorials' ? 'active' : ''"
        (click)="navigate('video-tutorials')"
        ><span
          ><img
            src="../../../assets/icons/icon_video_tutorial_inactive.svg"
            class="icon"
            style="height: 32px"
            alt="" /><img
            src="../../../assets/icons/icon_video_tutorial_active-1.svg"
            class="active-icon"
            style="height: 32px"
            alt=""
        /></span>
        {{ 'sitebar.video_tutorials' | translate }}</a
      >
    </li>
    <li class="nav-item">
      <a
        class="nav-link to-be-hidden"
        [class]="activeTab == '/faq' ? 'active' : ''"
        (click)="navigate('faq')"
        ><span
          ><img
            src="../../../assets/icons/icon_faq_inactive.svg"
            class="icon"
            style="height: 32px"
            alt="" /><img
            src="../../../assets/icons/icon_faq_active.svg"
            class="active-icon"
            style="height: 32px"
            alt=""
        /></span>
        Info & FAQ</a
      >
    </li>
    <li class="text-center nav-item logout-li">
      <a class="nav-link logout" (click)="logout()"
        >{{ 'sitebar.logout' | translate }}
        <!-- <i class="fa fa-sign-out" aria-hidden="true"></i> -->
      </a>
    </li>
    <li class="collapse text-center nav-item">
      <a class="nav-link" style="cursor: pointer" (click)="collapsed = !collapsed">
        <i
          class="fa"
          [ngClass]="collapsed ? 'fa-chevron-right' : 'fa-chevron-left'"
          aria-hidden="true"
        ></i>
      </a>
    </li>
  </ul>
  <div class="selector nav-item">
    <div *ngIf="isMowaAdmin" class="mb-3 selector-content">
      {{ ('SERVER' | translate) + ': ' }}
      <div>
        <span [class]="server == 'CH' ? 'active-lang' : ''" (click)="setServerByMowaAdmin('CH')"
          >CH</span
        >
        <span [class]="server == 'EU' ? 'active-lang' : ''" (click)="setServerByMowaAdmin('EU')"
          >EU</span
        >
      </div>
    </div>
    <div class="selector-content">
      {{ ('sitebar.language' | translate | uppercase) + ': ' }}
      <div>
        <span [class]="language == 'de' ? 'active-lang' : ''" (click)="setLanguage('de')">DE</span>
        <span [class]="language == 'en' ? 'active-lang' : ''" (click)="setLanguage('en')">EN</span>
      </div>
    </div>
  </div>
</nav>
<div *ngIf="modalActive" class="modal-container" (click)="closeModal()">
  <div class="modal-content text-center">
    <div class="close-btn">
      <img src="../../../assets/icons/close.png" alt="" />
    </div>
    <h2>{{ server + ' Server' + ('response.change_api' | translate) }}</h2>
  </div>
</div>
